export function parseRGB(inputString) {
  // Remove the parentheses and split the string by comma
  const rgbParts = inputString.replace(/[()]/g, '').split(',');

  // Parse each part as an integer
  const r = parseInt(rgbParts[0].trim(), 10);
  const g = parseInt(rgbParts[1].trim(), 10);
  const b = parseInt(rgbParts[2].trim(), 10);

  // Return the RGB values as an object
  return { r, g, b };
}

// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}

export function rgbToHex(rgbString) {
  // We store rgb colours as bracketed strings (0,20,233)
  if (rgbString) {
    let rgbArray = rgbString.replace('(', '').replace(')', '').split(',');
    let r = parseInt(rgbArray[0]);
    let g = parseInt(rgbArray[1]);
    let b = parseInt(rgbArray[2]);

    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
  } else {
    return null;
  }
}

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})` : null;
}
